import React from 'react';
import R from 'ramda';
import Helmet from 'react-helmet';
import { Header, Loading, Footer } from '../app/components';
import { connect } from 'react-redux';
import { firebase } from '../../common/lib/redux-firebase';
import { onPropertyDetailsPresence } from '../../common/properties/actions';
import { onUserDetailsPresence } from '../../common/users/actions';
import PropertyDetails from './PropertyDetails';

class PropertyDetailsPage extends React.Component {
  componentDidMount = () => { if (this.node) { this.node.scrollIntoView(); } }

  render() {
    const { location, propertyDetails, userDetails } = this.props;
    if (propertyDetails === undefined) {
      return <Loading loading loadingColor="#00E39A" backgroundColor="#ffffff" />;
    }

    if (propertyDetails === null) {
      return (
        <div>
          <div className="property-details-page not-found">
            <Helmet title="Eign fannst ekki - Húsfinnur" />
            <Header title="Eign fannst ekki" from="/" />
            <h2>Eign fannst ekki :(</h2>
          </div>
          <Footer />
        </div>
      );
    }

    return (
      <div className="property-details-page" ref={node => (this.node = node)}>
        <Helmet title={`${propertyDetails.address} - Eignaupplýsingar - Húsfinnur`} />
        <Header title="Eignaupplýsingar" from={`/properties/${propertyDetails.id}`} />
        <PropertyDetails
          location={location}
          propertyDetails={propertyDetails}
          userDetails={userDetails}
        />
        <Footer />
      </div>
    );
  }
}

PropertyDetailsPage.propTypes = {
  location: React.PropTypes.any,
  params: React.PropTypes.object.isRequired,
  propertyDetails: React.PropTypes.object,
  userDetails: React.PropTypes.object,
};

export default R.compose(
  connect(
    state => ({
      propertyDetails: state.properties.propertyDetails,
      userDetails: state.users.userDetails,
    }),
    { onPropertyDetailsPresence, onUserDetailsPresence },
  ),
  firebase((database, props) => {
    const propertyDetailsPresenceRef = database.child('properties').child(props.params.propertyId);
    return [
      [propertyDetailsPresenceRef, 'on', 'value', (snap) => {
        props.onPropertyDetailsPresence(snap);
        const userDetailsPresenceRef = database.child('users').child(snap.val().ownerId);
        userDetailsPresenceRef.on('value', props.onUserDetailsPresence);
      }],
    ];
  }),
)(PropertyDetailsPage);



// WEBPACK FOOTER //
// ./src/browser/propertyDetails/PropertyDetailsPage.js